import React, { useEffect } from "react";
import "../CSS/project.css";
import "../App.css";
import projecticon from "../Images/navbar/projects.png";
import Todoicon from "../Images/todo.png";
import disasterrecoveryimg from "../Images/disaster.png";
import texteditorimg from "../Images/texteditor.png";
import technohackimg from "../Images/technohack.png";
import profitpredictionimg from "../Images/profitprediction.png";
import tictactoeimg from "../Images/tictactoe.png";
import minesweeperimg from "../Images/minesweeper.png";

function Project({ setindex }) {
  useEffect(() => {
    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.2,
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setindex(3);
        }
      });
    }, options);

    const divs = document.getElementById("projects");
    observer.observe(divs);

    return () => {
      observer.unobserve(divs);
    };
  }, []);
  useEffect(() => {
    const options = {
      root: null, // Use the viewport as the root
      rootMargin: "0px",
      threshold: 0.2,
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("project-animate");
        } else {
          entry.target.classList.remove("project-animate");
        }
      });
    }, options);

    const div1 = document.querySelectorAll(".grid-hide");
    div1.forEach((item) => {
      observer.observe(item);
    });

    return () => {
      div1.forEach((item) => {
        observer.unobserve(item);
      });
    };
  });
  return (
    <div id="projects" className="projects">
      <div className="header-block fontbold">
        <img src={projecticon} alt="intro" />
        Projects
      </div>
      <br />
      <br />
      <div>
        <div className="page-heading fontbold">
          My <span className="namecolor">Projects</span>
        </div>
        <hr />
        <div className="project-flex-container">
          <div className="project-grid grid-hide">
            <div className="block-half">
              <div className="block-background">
                <img src={Todoicon} alt="todo app" />
              </div>
              <div>To Do app using MERN stack</div>
            </div>

            <div className="block-half">
              <div className="block-background">
                <img src={disasterrecoveryimg} alt="todo app" />
              </div>
              <div>Natural disaster and recovery website</div>
            </div>

            <div className="block-half">
              <div className="block-background">
                <img src={texteditorimg} alt="todo app" />
              </div>
              <div>Text editor made using HTML, CSS, Javascript </div>
            </div>

            <div className="block-half">
              <div className="block-background">
                <img src={technohackimg} alt="WeatherForecast" />
              </div>
              <div>Weather forecast using ARIMA model </div>
            </div>

            <div className="block-half">
              <div className="block-background">
                <img src={profitpredictionimg} alt="WeatherForecast" />
              </div>
              <div>Profit Prediction using Linear Regression</div>
            </div>

            <div className="block-half">
              <div className="block-background">
                <img src={tictactoeimg} alt="WeatherForecast" />
              </div>
              <div>AI based Tic Tac Toe game using Python</div>
            </div>

            <div className="block-half">
              <div className="block-background">
                <img src={minesweeperimg} alt="WeatherForecast" />
              </div>
              <div>AI based Minesweeper game using Python</div>
            </div>
          </div>
        </div>
        <br />
        <br />
      </div>
    </div>
  );
}

export default Project;
